import { render, staticRenderFns } from "./CusromUpload.vue?vue&type=template&id=6cf17526&scoped=true"
import script from "./CusromUpload.vue?vue&type=script&lang=js"
export * from "./CusromUpload.vue?vue&type=script&lang=js"
import style0 from "./CusromUpload.vue?vue&type=style&index=0&id=6cf17526&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf17526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf17526')) {
      api.createRecord('6cf17526', component.options)
    } else {
      api.reload('6cf17526', component.options)
    }
    module.hot.accept("./CusromUpload.vue?vue&type=template&id=6cf17526&scoped=true", function () {
      api.rerender('6cf17526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadImg/CusromUpload.vue"
export default component.exports